import httpService from './httpService';

const download = (dateFilter) => httpService.post('/api/activity/download', dateFilter);

export default { download };
